import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import utils from "../utils/utils";
import ImageUpload from "./imageUpload";
import apiCalls from "../utils/apiCalls";

const ImagesForm = ({images, uploadImage, onImagesChange}) => {
  const [pendingImages, setPendingImages] = useState([]);
  const [failedImages, setFailedImages] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!pendingImages.length) {
      return
    }

    setLoading(true);
    const newUploadedImages = [];
    pendingImages.reduce((promiseChain, image) => {
      return promiseChain.then(() =>
        uploadImage(image)
          .then((result) => {
            newUploadedImages.push(result.data.uploadedImage);
            onImagesChange([...images, ...newUploadedImages]);
          })
          .catch((errors) => {
            const failedImage = Object.assign({}, image);
            failedImage.errorMessage = utils.getErrorMessageFromResponse(errors, true);
            setFailedImages([...failedImages, failedImage]);
            return Promise.resolve();
          })
      );
    }, Promise.resolve()).then(() => {
      setPendingImages([]);
      setLoading(false);
    });
  }, [pendingImages]);

  const deleteImage = (uploadedImage) => {
    setLoading(true);

    apiCalls.deleteImage(uploadedImage)
      .then(() => {
        const newUploadedImages = images;
        const deletedIndex = newUploadedImages.findIndex(image => image.id === uploadedImage.id);
        if (deletedIndex >= 0) {
          newUploadedImages.splice(deletedIndex, 1)
        }
        onImagesChange(newUploadedImages);
        setLoading(false);
      });
  };

  const reorderImages = ({oldIndex, newIndex}) => {
    const newImages = images;
    const [removed] = newImages.splice(oldIndex, 1);
    newImages.splice(newIndex, 0, removed);
    onImagesChange(newImages);
  };

  return (
    <div>
      <ImageUpload onSubmit={setPendingImages}
                   multiple={ true }
                   loading={ loading }
                   pendingImages={pendingImages}
                   uploadedImages={images}
                   deleteImage={deleteImage}
                   reorderImages={reorderImages}
                   failedImages={failedImages}/>
    </div>
  );
}

ImagesForm.propTypes = {
  images: PropTypes.array.isRequired,
  uploadImage: PropTypes.func.isRequired,
  onImagesChange: PropTypes.func.isRequired,
};

ImagesForm.defaultProps = {};

export default ImagesForm;